import React, { useContext, useState, useRef, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';

import { AuthContext } from "../context/AuthContext.jsx";
import { useApiContext } from "../context/ApiContext.jsx";


const Performance = ({ analysis, questions, activeTab }) => {
	const { sessionInfo, setSessionInfo } = useContext(AuthContext);
	const { api, isDemo } = useApiContext();

	if (!analysis) return null;

	const getQuestionByItem = (el) => {
		if (!questions || !questions.length) return null;

		return questions.find(
			(q) => String(q.id) === String(el.questionId)
		);
	};

	const getCorrectAnswers = (el) => {
		const question = getQuestionByItem(el);
		if (!question || !Array.isArray(question.availableChoices)) {
			return <span>N.D.</span>;
		}

		const correctIds = Array.isArray(el.correctChoiceIds) ? el.correctChoiceIds.map((x) => x.toString()) : [];
		const selectedIds = Array.isArray(el.selectedChoiceIds) ? el.selectedChoiceIds.map((x) => x.toString()) : [];

		const correctChoices = question.availableChoices.filter((choice) =>
			correctIds.includes(choice.id.toString())
		);

		if (!correctChoices.length) {
			return <span>N.D.</span>;
		}

		return (
			<ol className="ps-1 ms-1">
				{correctChoices.map((choice) => {
					const choiceId = choice.id.toString();
					const isSelected = selectedIds.includes(choiceId);
					const isMissedCorrect = !isSelected;

					return (
						<li key={choiceId}>
							<span style={{ fontWeight: isMissedCorrect ? 700 : undefined }}>
								{choice.title}
							</span>
						</li>
					);
				})}
			</ol>
		);
	};

	const getSelectedAnswers = (el) => {
		const question = getQuestionByItem(el);
		if (!question || !Array.isArray(question.availableChoices)) {
			return <span>N.D.</span>;
		}

		const correctIds = Array.isArray(el.correctChoiceIds) ? el.correctChoiceIds.map((x) => x.toString()) : [];
		const selectedIds = Array.isArray(el.selectedChoiceIds) ? el.selectedChoiceIds.map((x) => x.toString()) : [];

		const selectedChoices = question.availableChoices.filter((choice) =>
			selectedIds.includes(choice.id.toString())
		);

		if (!selectedChoices.length) {
			return <span>N.D.</span>;
		}

		return (
			<ol className="ps-1 ms-1">
				{selectedChoices.map((choice) => {
					const choiceId = choice.id.toString();
					const isCorrect = correctIds.includes(choiceId);
					const isWrongSelected = !isCorrect;

					return (
						<li key={choiceId}>
							<span style={{ color: isWrongSelected ? '#dc3545' : undefined }}>
								{choice.title}
							</span>
						</li>
					);
				})}
			</ol>
		);
	};

	/**
	 * Converte una durata in secondi in formato hh:mm:ss
	 * @param {number} totalSeconds - Durata in secondi, può avere la frazione
	 * @param {boolean} includeFraction - opzionale, se true mostra i millisecondi
	 * @returns {string} hh:mm:ss o hh:mm:ss.sss
	 */
	const formatDuration = (totalSeconds, includeFraction = false) => {
		if (isNaN(totalSeconds) || totalSeconds < 0) return null;

		const hours = Math.floor(totalSeconds / 3600);
		const minutes = Math.floor((totalSeconds % 3600) / 60);
		const seconds = Math.floor(totalSeconds % 60);

		// frazione di secondo opzionale
		const fraction = totalSeconds % 1;
		const fractionString = includeFraction && fraction > 0 ? String(Math.round(fraction * 1000)).padStart(3, '0') : '';

		if (includeFraction && fractionString) {
			return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}.${fractionString}`;
		}

		return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
	};

	// FIXME: gestire meglio il tempo di download 
	const handleDownloadReport = async (ev, sessionId) => {
		ev.preventDefault();
		if (isDemo) return;

		// Apri subito una tab (popup-blocker friendly)
		const newTab = window.open('', '_blank');

		const res = await api.get(`/api/trivia/report/${sessionId}`, {
			responseType: 'blob',
			headers: { Accept: 'application/pdf' }
		});

		const contentType = res?.headers?.['content-type'] || 'application/pdf';
		const blob = new Blob([res.data], { type: contentType });
		const objectUrl = URL.createObjectURL(blob);

		if (!newTab) {
			// fallback se il popup blocker ha bloccato la tab
			window.open(objectUrl, '_blank');
			return;
		}

		newTab.location = objectUrl;

		// libera la risorsa dopo un po' (lascia tempo al browser di caricare il PDF)
		setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
	};

	return (
		<>
			<div className={`animate__animated animate__fadeIn px-2 px-sm-3 px-lg-5 w-100 mt-5 mt-sm-7 ${activeTab != 1 ? "d-none" : ""}`} style={{ animationdDuration: "0.3s" }}>
				<div className="text-center mb-5">
					<img src={`/img/react-app/avatars/01/avatar-${analysis.avatarId || "default"}.png`} style={{ width: 120, height: "auto" }} className="user-avatar user-avatar-main mx-auto" />
					<h2 className="fw-bold fs-2 mt-1 mb-3">{analysis.nickName}</h2>
				</div>

				<div className="performance-analysis">
					<div className="btn btn-primary p-4 d-flex flex-column justify-content-center align-items-center">
						{/*<h2 className="mb-0" style={{ fontWeight: 900, fontSize: "4rem", color: "var(--active-tab-bg)" }}>{sessionInfo.scoresEnabled ? analysis.totalScore : "N.D."}</h2>*/}
						<h2 className="mb-0" style={{ fontWeight: 900, fontSize: "4rem", color: "var(--active-tab-bg)" }}>{analysis.totalScore}</h2>
						<h3 className="fs-4 mb-0">Punteggio finale</h3>
					</div>
					<div className="btn btn-primary p-4 d-flex flex-column justify-content-center align-items-center">
						<h2 className="mb-0" style={{ fontWeight: 900, fontSize: "3rem", color: "var(--btn-primary-selected-bg)" }}>{analysis.successAnswers}</h2>
						<h3 className="fs-4 mb-0">Risposte corrette</h3>
					</div>
					<div className="btn btn-primary p-4 d-flex flex-column justify-content-center align-items-center">
						<h2 className="mb-0 text-danger" style={{ fontWeight: 900, fontSize: "3rem" }}>{analysis.errorAnswers}</h2>
						<h3 className="fs-4 mb-0">Risposte errate</h3>
					</div>

					<div className="performance-value text-white p-4 d-flex flex-column justify-content-center align-items-center">
						<h2 className="time-span mb-0" style={{ fontWeight: 700, fontSize: "3rem" }}>{formatDuration(analysis.totalSeconds) || "N.D."}</h2>
						<h3 className="fs-4 mb-0">Tempo totale</h3>
					</div>

					<div className="performance-value text-white p-4 d-flex flex-column justify-content-center align-items-center">
						<h2 className="mb-0" style={{ fontWeight: 700, fontSize: "3rem" }}>#{analysis.position || "N.D."}</h2>
						<h3 className="fs-4 mb-0">Posizione globale</h3>
					</div>

					<a href="#" title={`${isDemo ? "Non disponibile nella versione demo" : "Scarica il report"}`} onClick={(ev) => handleDownloadReport(ev, analysis.sessionId)} className={`performance-value ${isDemo ? "disabled" : ""} p-4 d-flex flex-column justify-content-center align-items-center`}>
						<h2 className="mb-0" style={{ fontWeight: 900, fontSize: "3rem" }}>
							<i className="bi bi-box-arrow-down"></i>
						</h2>
						<h3 className="fs-4 mb-0">Scarica il report</h3>
					</a>
				</div>

				{analysis.items?.length ? (
					<>
						<h2 className="fw-bold d-flex align-items-center mb-4">
							<i className="bi bi-gem fs-3 me-3"></i>
							Il dettaglio della {sessionInfo.sessionType > 1 ? "" : "tua"} performance
						</h2>
						<div className="table-responsive">
							<table className="table table-striped table-hover bg-white performance-table m-0">
								<thead className="text-white" style={{ backgroundColor: "var(--game-subheader-bg-color)" }}>
									<tr> 
										<th>N</th>
										<th>DOMANDA</th>
										<th>RISPOSTE GIUSTE</th>
										<th>RISPOSTE SELEZIONATE</th>
										<th>PUNTI</th>
										<th className="text-nowrap lh-1">% CORRETTE<div className="fs-15 fw-light">delle risposte date</div></th>
										<th className="text-nowrap lh-1">% ERRATE<div className="fs-15 fw-light">delle risposte date</div></th>
									</tr>
								</thead>
								<tbody>
									{analysis.items.map((el, index) => {
										const q = getQuestionByItem(el);

										return (
											<tr key={index}>
												<td><strong>{String(index + 1).padStart(2, '0')}</strong></td>
												<td>{q?.description ?? `Domanda #${index + 1}`}</td>
												<td>{getCorrectAnswers(el)}</td>
												<td>{getSelectedAnswers(el)}</td>
												{/*<td className="text-center">{sessionInfo.scoresEnabled ? el.score : "N.D."}</td>*/}
												<td className="text-center">{el.score}</td>
												{isDemo ? (
													<>
														<td className="text-center">{el.percSuccess}%</td>
														<td className="text-center">{Math.round(100 - el.percSuccess).toFixed(1)}%</td>
													</>
												) : (
													<>
														<td className="text-center">{el.correctChoiceCount * 100}%</td>
														<td className="text-center">{el.incorrectChoiceCount * 100}%</td>
													</>
												)}
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</>
				) : ""}

			</div>
		</>
	);
};

export default Performance;
